// extracted by mini-css-extract-plugin
export default {"l":"ca0ef90a69"};